export default "__VITE_ASSET__ikDFSz2w__"